export default function StatCard({ icon, value, label, accentColor, onClick }: {
  icon: string; value: string; label: string; accentColor: string; onClick?: () => void
}) {
  const Tag = onClick ? 'button' : 'div'
  return (
    <Tag
      style={{
        ...styles.statCard,
        ...(onClick ? { cursor: 'pointer', border: '1.5px solid transparent', transition: 'border-color 0.15s ease' } : {}),
      }}
      className="fade-up"
      onClick={onClick}
      {...(onClick ? { 'aria-label': `${label}: ${value}` } : {})}
    >
      {/* Ghost number — purely decorative depth effect */}
      <span aria-hidden style={{ ...styles.statGhost, color: accentColor }}>
        {value === '—' ? '—' : value.replace(/[^0-9]/g, '') || value}
      </span>
      <div style={styles.statContent}>
        <span style={styles.statIcon}>{icon}</span>
        <div style={{ ...styles.statValue, color: accentColor }}>{value}</div>
        <div style={styles.statLabel}>{label}</div>
      </div>
    </Tag>
  )
}

/* ── Styles ──────────────────────────────────────────────────── */
const styles: Record<string, React.CSSProperties> = {
  statCardSkeleton: {
    height:       120,
    borderRadius: 16,
  },
  statCard: {
    position:     'relative',
    background:   '#FFFFFF',
    borderRadius: 16,
    padding:      '20px 18px 16px',
    boxShadow:    '0 2px 14px rgba(27,67,50,0.07)',
    border:       '1.5px solid #EFE7D7',
    overflow:     'hidden',
    minHeight:    110,
  },
  statGhost: {
    position:      'absolute',
    bottom:        -10,
    right:         -4,
    fontFamily:    "'Cormorant Garamond', serif",
    fontSize:      '5.5rem',
    fontWeight:    700,
    lineHeight:    1,
    opacity:       0.07,
    userSelect:    'none',
    pointerEvents: 'none',
    letterSpacing: '-0.04em',
  },
  statContent: {
    position: 'relative',
    zIndex:   1,
    display:  'flex',
    flexDirection: 'column',
    gap:      4,
  },
  statIcon: {
    fontSize:     '1.5rem',
    marginBottom: 4,
    lineHeight:   1,
  },
  statValue: {
    fontFamily:  "'Cormorant Garamond', serif",
    fontSize:    '2.4rem',
    fontWeight:  700,
    lineHeight:  1,
  },
  statLabel: {
    fontSize: '0.875rem',
    fontWeight:    700,
    textTransform: 'uppercase',
    letterSpacing: '0.07em',
    color:         '#9A8070',
  },
}